"use strict";

var _classCallCheck = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Main = void 0;

var main_slim_1 = require("./main.slim");

var AbsorbersPlugin_1 = require("./Plugins/Absorbers/AbsorbersPlugin");

var EmittersPlugin_1 = require("./Plugins/Emitters/EmittersPlugin");

var PolygonMaskPlugin_1 = require("./Plugins/PolygonMask/PolygonMaskPlugin");

var Main =
/*#__PURE__*/
function (_main_slim_1$MainSlim) {
  _inherits(Main, _main_slim_1$MainSlim);

  function Main() {
    var _this;

    _classCallCheck(this, Main);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Main).call(this));

    _this.addPlugin(AbsorbersPlugin_1.AbsorbersPlugin);

    _this.addPlugin(EmittersPlugin_1.EmittersPlugin);

    _this.addPlugin(PolygonMaskPlugin_1.PolygonMaskPlugin);

    return _this;
  }

  return Main;
}(main_slim_1.MainSlim);

exports.Main = Main;